/** Decode JWT `exp` (seconds) without verifying signature — client-side scheduling only. */
export function getJwtExpiryMs(token: string | null | undefined): number | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const payload = JSON.parse(
      atob(parts[1]!.replace(/-/g, "+").replace(/_/g, "/")),
    ) as { exp?: unknown };
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function accessTokenExpiresWithinMs(
  token: string | null | undefined,
  withinMs: number,
): boolean {
  const exp = getJwtExpiryMs(token);
  if (exp === null) return false;
  return exp - Date.now() <= withinMs;
}
